var _defs, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAzureLighthouseLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "azureLighthouseGrad",
    x1: 9,
    y1: 17.86,
    x2: 9,
    y2: 4.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0078d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1380da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#3c91e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#559cec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5ea0ef"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#azureLighthouseGrad)",
    d: "M16.65 17.08l-3.59-9.32a.28.28 0 00-.26-.18h-2.56V5.36a1.3 1.3 0 10-2.59 0v2.22H5.34a.29.29 0 00-.27.18l-3.72 9.32a.55.55 0 00.45.78h14.4a.55.55 0 00.45-.78z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#83b9f9",
    d: "M3.37 12L12 7.58h.75a.28.28 0 01.27.19l.83 2.15L1.8 16zM9.54 17.84l6-3.6 1.09 2.84a.56.56 0 01-.46.78z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0078d4",
    d: "M8.87.16L4.75 2.55a.16.16 0 00-.08.14v.37a.16.16 0 00.16.16h.62v4.36h.78V3.22h5.44v4.36h.77V3.22h.63a.16.16 0 00.16-.16v-.37a.16.16 0 00-.08-.14L9 .16a.22.22 0 00-.13 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureLighthouseLogo);
export default __webpack_public_path__ + "static/media/azure_lighthouse_logo.cb50a74d6a3e3adcf217c70fc59b1cae.svg";
export { ForwardRef as ReactComponent };